
import AddReduceDebit from  '@/components/Accounting/AddReduceDebit/AddReduceDebit'
import Withdraw from  '@/components/Accounting/Withdraw/Withdraw'

export default [
      {
        path: '/withdraw/:pageCode',
        name: 'withdraw',
        props: true,
        component: Withdraw
      },
      {
        path: '/addReduceDebit/:pageCode',
        name: 'addReduceDebit',
        props: true,
        component: AddReduceDebit
      }
    
]